import { useEffect, useState } from 'react';
import TitleUnderline from 'components/TitleUnderline';
import EmptyBlock from 'components/EmptyBlock';
import styles from 'styles/modules/NewsStory.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
    handleHidePopup,
    handleShowPopup,
    setPopupConfig,
    setPopupLoading,
} from 'store/ux';
import { useRouter } from 'next/router';
import { authSelector } from 'store/auth';
import AddContent from './AddContent';
import Card from 'components/Card';
import { profile } from 'lang/en.json';
import Typo from 'components/Typo';
import { removeAlert } from 'store/alert';

const resultsPerPage = 3;
const Alerts = ({ data, empty }) => {
    const { isAuthorized } = useSelector(authSelector);
    const dispatch = useDispatch();
    const [resultsToShow, setResultsToShow] = useState([]);
    const [loadMoreActive, setLoadMoreActive] = useState(false);
    const [stories, setStories] = useState(data);
    const [next, setNext] = useState(resultsPerPage);
    const router = useRouter();

    useEffect(() => {
        setStories(data);
        loopWithSlice(resultsPerPage);
    }, [data]);

    let holdingResults = [];
    const loopWithSlice = (end) => {
        const slicedResults = data?.slice(0, end);
        holdingResults = slicedResults
            ? [...holdingResults, ...slicedResults]
            : null;
        setResultsToShow(holdingResults);

        if (end >= stories?.length) {
            setLoadMoreActive(false);
        } else {
            setLoadMoreActive(true);
        }
    };

    const handleRemovePopup = (id) => {
        dispatch(handleShowPopup());
        dispatch(
            setPopupConfig({
                onConfirm: () => handleRemoveConfirm(id),
                onCancel: handleRemoveCancel,
                title: 'Delete News alert?',
                confirmTitle: 'Confirm',
                cancelTitle: 'Cancel',
            })
        );
    };

    const handleRemoveConfirm = async (id) => {
        dispatch(setPopupLoading(true));
        await dispatch(removeAlert(id));
        dispatch(setPopupLoading(false));
        dispatch(handleHidePopup());
    };

    const handleRemoveCancel = () => {
        dispatch(handleHidePopup());
    };

    const handleAddNewsAlert = () => {
        router
            .push(`${router.asPath}/news-alerts`)
            .then(() => window.scrollTo(0, 0));
    };

    const handleLoadMore = () => {
        const nextNum = next + resultsPerPage;
        loopWithSlice(nextNum);
        setNext(nextNum);
    };

    return (
        <div>
            <TitleUnderline className={'mb-m'}>
                <Typo Tag={'h2'} variant={'eyebrow'}>
                    {profile.news_alerts.title}
                </Typo>
                <div className={styles.addBtnWrapper}>
                    <AddContent
                        data={{
                            direction: 'row',
                            label: profile.news_alerts.button,
                            onClick: handleAddNewsAlert,
                            reverted: true,
                            blue: true,
                            labelHideMob: true,
                        }}
                    />
                </div>
            </TitleUnderline>

            <div className="mb-l">
                <div className={styles.newsStory}>
                    {resultsToShow
                        ?.slice(0, 5)
                        .map(
                            (
                                { title, body, date, publisher, slug, id },
                                key
                            ) => {
                                return (
                                    <Card
                                        title={title}
                                        body={body}
                                        date={date}
                                        source={publisher}
                                        key={`SingleCard-item-${key}`}
                                        link={`/news-alerts/${slug}`}
                                        onRemove={
                                            isAuthorized && handleRemovePopup
                                        }
                                        cta={'Read more'}
                                        id={id}
                                    />
                                );
                            }
                        )}
                </div>

                {resultsToShow?.length < 1 && (
                    <EmptyBlock title={empty.title} />
                )}
            </div>
        </div>
    );
};

export default Alerts;
